const columns = [{ title: 'Toxin', field: 'name' }];

export default columns;
